<template>
  <div class="cmp-product-price" v-if="showPrices" :class="{ 'incl-excl': priceType, [parentClassRef]: parentClassRef  }">
    <!-- BESPOKE WIVO-53: Add an extra class when we display the Prijs vanaf label -->
    <ul class="price-list flex-row-nowrap align-items-baseline" :class="{ 'show-price-starting': showPriceStarting }">
    <!-- END BESPOKE WIVO-53 -->

      <!-- BESPOKE WIVO-53 -->
      <li v-if="showPriceStarting" class="starting-at">Prijs vanaf: </li>
      <!-- END BESPOKE WIVO-53 -->
      <li class="default">
        <span>{{ prices.price }}</span>
      </li>
      <li v-if="prices.isSalesAction" class="original salesaction">
        <span>{{ prices.basePrice }}</span>
      </li>
      <li v-if="showExclVat" class="vat-notation">
        <span v-translation="{ type: 'label', code: 'label_price1_excl_vat' }"></span>
      </li>
    </ul>
    <ul v-if="showExclVat" class="price-list flex-row-nowrap align-items-baseline price-incl">
      <li class="default">
        <span>{{ prices.priceIncl }}</span>
      </li>
      <li v-if="prices.isSalesAction" class="original salesaction">
        <span>{{ prices.basePriceIncl }}</span>
      </li>
      <li class="vat-notation"><span v-translation="{ type: 'label', code: 'label_price1_incl_vat' }"></span></li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    prices: { type: Object, required: false },
    parentClassRef: { type: String, default: '', required: false },
    // BESPOKE
    showPriceStarting: { type: Boolean, required: false, default: false }
    // END BESPOKE 
  },
  computed: {
    ...mapGetters(['showPrices', 'priceType']),
    showExclVat() {
      return this.priceType === 3;
    }
  }
}
</script>

<style>

</style>
